define('views/pages/claims/index',['require','views/base/page','views/pages/claims/collection','views/pages/claims/navbar','text!templates/pages/claims/index.ejs'],function(require) {
    'use strict';

    var PageView = require('views/base/page'),
        ClaimCollectionView = require('views/pages/claims/collection'),
        ClaimsNavbarView = require('views/pages/claims/navbar'),
        template = require('text!templates/pages/claims/index.ejs');

    var ClaimsPageView = PageView.extend({
        autoRender: true,
        template: template,
        id: 'pages-claims-page',
        listen: {
            'addedToDOM': 'onAddedToDOM'
        },
        windowResize: true,
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);
        },
        onAddedToDOM: function() {
            this.model.trigger('resize');
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('navbar', new ClaimsNavbarView({ model: this.model, container: this.el }));
            this.subview('collection', new ClaimCollectionView({ collection: this.model.items, model: this.model, container: this.el }));
        }
    });

    return ClaimsPageView;
});

